// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import type { ZodEnum } from 'zod';

export function serializePreferencesToSelection<T extends Record<string, boolean | undefined>>(
  preferences: T,
  menuItemSchema: ZodEnum<[string, ...string[]]>,
) {
  const selection = new Set<string>();

  for (const [k, v] of Object.entries(preferences)) {
    if (v === true) {
      try {
        selection.add(menuItemSchema.parse(k));
      } catch {
        // Ignore unknown properties gracefully
      }
    }
  }

  return selection;
}
